import cn from "../../lib/classnames";
import Column from "../grid/Column";
import Container from "../grid/Container";
import FirstFinancialBank from "../icons/FirstFinancialBank";
import Footer from "../Footer";
import gradientStyles from "../../styles/Gradient.module.css";
import React from "react";
import Row from "../grid/Row";
import styles from "./LandingPageWrapper.module.css";
import LegalInfo from "../LegalInfo";

type Props = {
    children: React.ReactNode;
    className?: string;
    logoClassName?: string;
    renderInterestRates?: boolean;
    renderBlueGradient?: boolean;
    onlyRenderCardBanner?: boolean;
};

export default function LandingPageWrapper({
    children,
    className,
    logoClassName,
    renderBlueGradient = true,
    renderInterestRates = true,
    onlyRenderCardBanner = false,
}: Props) {
    return (
        <>
            <div className={cn(!onlyRenderCardBanner ? styles.fullHeight : undefined, className)}>
                <div
                    className={cn(
                        renderBlueGradient ? gradientStyles.blue : undefined,
                        styles.gradientContainer,
                    )}
                >
                    <Container>
                        <Row className={styles.gradientRow}>
                            <Column className={logoClassName ? logoClassName : styles.logoColumn}>
                                <FirstFinancialBank
                                    className={
                                        renderBlueGradient ? styles.firstLogo : styles.secondLogo
                                    }
                                />
                            </Column>
                        </Row>
                    </Container>
                    {children}
                </div>
                {!onlyRenderCardBanner ? (
                    <LegalInfo renderInterestRates={renderInterestRates} />
                ) : null}
            </div>
            {!onlyRenderCardBanner ? <Footer /> : null}
        </>
    );
}
